import styled from 'styled-components';
import Typography from '@material-ui/core/Typography';

export const AppHeading = styled(Typography).attrs(() => ({
    variant: 'h3',
    component: 'h2'
}))``;
